import axios from 'axios'
import type { SessionFile, EmailData } from '@fowix/types'
import { useStore } from '../store/useStore'

const API_URL = process.env.API_URL

export const getSessionFiles = async (sessionId: string) => {
  try {
    const response = await fetch(`${API_URL}/sessions/${sessionId}?include_public_urls=true`)
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    
    const data = await response.json()
    console.log('Session data:', data) // Debug log
    
    // Store expiration time
    useStore.getState().setExpiresAt(data.expires_at)
    
    return data.files.map((file: SessionFile) => ({
      id: file.id,
      name: file.name,
      url: file.url,
      public_url: file.public_url,
      type: file.type,
      size: file.size,
      created_at: file.created_at,
      updated_at: file.updated_at,
      selected: false,
      order: null,
    }))
  } catch (error) {
    console.error('Error fetching session files:', error)
    throw error
  }
}

export const generatePDF = async (sessionId: string, fileIds?: string[]) => {
  try {
    const queryParams = fileIds ? `?files=${fileIds.join(',')}` : ''
    const response = await axios.get(
      `${API_URL}/sessions/${sessionId}/pdf${queryParams}`,
      { responseType: 'blob' }
    )
    return response.data
  } catch (error) {
    console.error('Error generating PDF:', error)
    throw error
  }
}

export const sendPDFByEmail = async (sessionId: string, data: EmailData) => {
  const response = await fetch(`${API_URL}/sessions/${sessionId}/pdf/email`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      to: data.to,
      files: data.files,
      fileName: data.filename
    }),
  })

  if (!response.ok) {
    throw new Error('Failed to send PDF via email')
  }

  return response.json()
}

export const sendPDFByWhatsApp = async (sessionId: string, fileIds?: string[]) => {
  try {
    const queryParams = fileIds ? `?files=${fileIds.join(',')}` : ''
    const response = await axios.post(
      `${API_URL}/sessions/${sessionId}/pdf/whatsapp${queryParams}`
    )
    return response.data
  } catch (error) {
    console.error('Error sending PDF by WhatsApp:', error)
    throw error
  }
} 